import React, { useState, useEffect } from "react";
// import './FilterSidebar.css'

const FilterSidebar = ({ filters, onFilterChange }) => {
    const [hotelType, setHotelType] = useState([]);
    const [popular, setPopular] = useState([]);
    const [rating, setRating] = useState("");
    const [isClicked, setIsClicked] = useState(false);


    const togglePopular = (label) => {
        setPopular((prev) =>
            prev.includes(label) ? prev.filter((l) => l !== label) : [...prev, label]
        );
    };

    const updateRating = (value) => {
        setRating(value);
    };
    const updateHotelType = (value) => {
        setIsClicked(!isClicked);
        const updated = hotelType.includes(value)
            ? hotelType.filter((item) => item !== value)
            : [...hotelType, value];
        setHotelType(updated);
        console.log(updated);
    }
    useEffect(() => {
        console.log("Calling onFilterChange", { popular, rating, hotelType });
        if (onFilterChange) {
            onFilterChange({ popular, rating, hotelType });
        }
    }, [popular, rating, hotelType]);
    const popularOptions = [
        "Free Cancellation",
        "Free Breakfast",
        "Rated Exceptional(9+)",
        "Parking Available",
    ];

    const ratingOptions = ["Exceptional: 9+", "Excellent: 8+"];

    return (
        <div className="hidden lg:block w-72 bg-gray-50 p-5 rounded-xl shadow-sm sticky top-20 h-max">
            <h2 className="text-xl font-bold mb-4">Filters</h2>

            <div className="mb-6">
                <h3 className="text-lg font-semibold mb-2">Hotel Type</h3>
                {/* <div className="flex items-center border border-gray-300 rounded-full px-3 py-2">
          <input
            type="text"
            placeholder="Enter area, locality or hotel"
            className="flex-1 outline-none text-sm bg-transparent"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <span className="text-gray-500 text-lg">🔍</span>
        </div> */}
                {['5 star', '4 star', '3 star'].map((star) => (
                    <button key={star}
                        onClick={() => updateHotelType(star)}
                        className={`px-4 py-2 rounded-full border text-sm shadow-sm ${hotelType.includes(star)
                                ? "bg-blue-500 text-white border-blue-500"
                                : "bg-white text-gray-700 border-gray-300"
                            }`} >{star}</button>
                ))}
            </div>

            <div className="mb-6">
                <h3 className="text-lg font-semibold mb-2">Most Popular</h3>
                {popularOptions.map((item, idx) => (
                    <div key={idx} className="flex justify-between items-center mb-2">
                        <label className="text-sm">{item}</label>
                        <input
                            type="checkbox"
                            checked={popular.includes(item)}
                            onChange={() => togglePopular(item)}
                        />
                    </div>
                ))}
            </div>

            <div>
                <h3 className="text-lg font-semibold mb-2">User Rating</h3>
                {ratingOptions.map((item, idx) => (
                    <div key={idx} className="flex justify-between items-center mb-2">
                        <label className="text-sm">{item}</label>
                        <input
                            type="radio"
                            name="rating"
                            checked={rating === item}
                            onChange={() => updateRating(item)}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FilterSidebar;
